import { supabase } from '@/lib/supabase'
import { withinDeadline } from './platformDeadline'
export { withinDeadline } from './platformDeadline'
import { record, type DashboardRequest } from '../../supabase/functions/_shared/platform-cost-contract.ts'


export async function dashboardRequest(body: DashboardRequest, signal?: AbortSignal): Promise<unknown> {
  const deadline = signal ? AbortSignal.any([signal, AbortSignal.timeout(15_000)]) : AbortSignal.timeout(15_000)
  return withinDeadline((async () => {
    const { data, error } = await supabase.auth.getSession()
    if (error || !data.session) throw new Error('Sign in to continue.')
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL.trim()}/functions/v1/hella-dashboard-rize`, {
      method: 'POST', signal: deadline,
      headers: { 'Content-Type': 'application/json', apikey: import.meta.env.VITE_SUPABASE_ANON_KEY.trim(), Authorization: `Bearer ${data.session.access_token}` },
      body: JSON.stringify(body),
    })
    const value: unknown = await response.json()
    if (!response.ok) throw new Error(record(value) && typeof value.error === 'string' ? value.error : 'Reporting unavailable.')
    return value
  })(), deadline)
}
